import React, { useState, useEffect } from "react";
import { Button, Container, Row, Form } from 'react-bootstrap'
import { useHistory } from 'react-router'
import { useLocation } from 'react-router-dom'
import firebase from 'firebase/compat/app';
import { getAuth } from "firebase/auth";
import "firebase/database"
import './AddProduct.css'

function EditProduct() {

    const history = useHistory()

    const auth = getAuth();
    const user = auth.currentUser;
    const uid = user.uid;

    const location = useLocation();

    const [productName, setProductName] = useState("")
    const [barcode, setBarcode] = useState("")
    const [code, setCode] = useState("")
    const [id, setId] = useState("")

    useEffect(() => {
        setProductName(location.state.productName)
        setBarcode(location.state.barcode)
        setCode(location.state.code)
        setId(location.state.id)
    }, [location])

    function editProduct(e) {
        e.preventDefault()
        const newProductRef = firebase.database().ref(uid + "/newProduct/" + id)
        console.log("ovo je" + newProductRef)
        newProductRef.update({
            productName: productName,
            barcode: barcode,
            code: code
        })


        setProductName("")
        setBarcode("")
        setCode("")

    }

    function handleChange1(e) {
        setProductName(e.target.value)
    }

    function handleChange2(e) {
        setBarcode(e.target.value)
    }

    function handleChange3(e) {
        setCode(e.target.value)
    }


    function routeChangeBack() {
        let path = `products`
        history.push(path)
    }

    return (
        <div>
            <Container id="addprod">
                <Row>
                    <h4>Edit product info</h4>
                    {/* {alert && <Alert variant="success">{alert}</Alert>} */}
                    <Form onSubmit={editProduct}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Edit product name</Form.Label>
                            <Form.Control className="input-color" onChange={handleChange1} value={productName} as="textarea" placeholder="Enter product name" onFocus={(e) => e.target.placeholder = ""} onBlur={(e) => e.target.placeholder = "Enter product name"} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label> Edit product barcode</Form.Label>
                            <Form.Control className="input-color" onChange={handleChange2} value={barcode} as="textarea" placeholder="Enter barcode" onFocus={(e) => e.target.placeholder = ""} onBlur={(e) => e.target.placeholder = "Enter barcode"} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Edit custom code</Form.Label>
                            <Form.Control className="input-color" onChange={handleChange3} value={code} as="textarea" placeholder="Enter your custom code" onFocus={(e) => e.target.placeholder = ""} onBlur={(e) => e.target.placeholder = "Enter your custom code"} />
                        </Form.Group>
                        <Button onClick={routeChangeBack} variant="secondary" type="button">Back</Button>
                        <Button className="float-end" variant="dark" type="submit">Save changes</Button>
                    </Form>
                </Row>
            </Container>
        </div>
    )
}

export default EditProduct
